module.exports = __webpack_public_path__ + "static/media/googleLogo.7ecfb55b.svg";